import Styled from 'styled-components'

export const Category = Styled.h1`
`

export const Banner = Styled.div`
`

export const CotainerProduct = Styled.div`
`

export const CheckboxContainer = Styled.div`
`

export const Checkbox = Styled.input`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`

export const FeaturedCategoriesBrands = Styled.div`
`

export const TitleProduct = Styled.p`
`
export const Label = Styled.p`
`

export const ContainerCarrousel = Styled.div`
`
export const Title = Styled.p`
`